import { render, staticRenderFns } from "./InvoiceNotification.vue?vue&type=template&id=0bad5dce&scoped=true"
import script from "./InvoiceNotification.vue?vue&type=script&lang=js"
export * from "./InvoiceNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bad5dce",
  null
  
)

export default component.exports